import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useIntl } from 'react-intl'

interface ConfirmationModalProps {
    show: boolean
    onHide: () => void
    onConfirm: () => void | Promise<void>
    title: string
    message: React.ReactNode
    confirmText?: string
    cancelText?: string
    variant?: 'primary' | 'danger' | 'warning' | 'success'
    loading?: boolean
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    show,
    onHide,
    onConfirm,
    title,
    message,
    confirmText = 'Confirm',
    cancelText,
    variant = 'primary',
    loading = false,
}) => {
    const intl = useIntl()
    const cancelLabel =
        cancelText ?? intl.formatMessage({ id: 'common.action.cancel', defaultMessage: 'Cancel' })
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {typeof message === 'string' ? <p>{message}</p> : message}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={loading}>
                    {cancelLabel}
                </Button>
                <Button variant={variant} onClick={onConfirm} disabled={loading}>
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Loading...
                        </>
                    ) : (
                        confirmText
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
